/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S12_Li1Inputs */

const tr_onbilgi_s12_li1 = /** @type {(inputs: Onbilgi_S12_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onay kutularının işaretlenmesi, ön bilgilendirmenin alındığını ve sözleşme koşullarının kabul edildiğini gösterir. Ücretli döneme ilişkin Sözleşme, satın almanın onaylanması ve ödemenin alınmasıyla kurulur; cayma süresi bu tarihten itibaren işler.`)
};

const en_onbilgi_s12_li1 = /** @type {(inputs: Onbilgi_S12_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticking the confirmation boxes shows that the pre-contractual information has been received and the contract terms accepted. The Agreement for the paid period is concluded upon confirmation of the purchase and receipt of payment; the withdrawal period runs from that date.`)
};

const de_onbilgi_s12_li1 = /** @type {(inputs: Onbilgi_S12_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ankreuzen der Bestätigungsfelder belegt den Erhalt der Vorabinformation und die Annahme der Vertragsbedingungen. Der Vertrag über den kostenpflichtigen Zeitraum kommt mit der Bestätigung des Kaufs und dem Eingang der Zahlung zustande; die Widerrufsfrist läuft ab diesem Zeitpunkt.`)
};

const ru_onbilgi_s12_li1 = /** @type {(inputs: Onbilgi_S12_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметка в полях подтверждения означает получение предварительной информации и принятие условий договора. Договор на платный период заключается с подтверждением покупки и получением оплаты; срок отказа исчисляется с этой даты.`)
};

/**
* | output |
* | --- |
* | "Ticking the confirmation boxes shows that the pre-contractual information has been received and the contract terms accepted. The Agreement for the paid perio..." |
*
* @param {Onbilgi_S12_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s12_li1 = /** @type {((inputs?: Onbilgi_S12_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S12_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s12_li1(inputs)
	if (locale === "de") return de_onbilgi_s12_li1(inputs)
	if (locale === "ru") return ru_onbilgi_s12_li1(inputs)
	return tr_onbilgi_s12_li1(inputs)
});